import { Button, Flex, Typography } from "antd"

export const CryptoTopUpStepUi = () => {
  return (
    <Typography.Text>
      If you choose to top up your balance with cryptocurrency, a window will
      appear displaying your personal wallet address. Simply send funds to this
      address, and your balance will be updated in the selected cryptocurrency
      (e.g., USDT TRC20) as soon as we detect the incoming transaction.
    </Typography.Text>
  )
}
